import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Contact.css';

function Contact() {
  const location = useLocation();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: ''
  });

  useEffect(() => {
    // If arriving from a product inquiry
    const searchParams = new URLSearchParams(location.search);
    const product = searchParams.get('product');
    if (product) {
      setFormData(prev => ({
        ...prev,
        subject: `Inquiry regarding: ${product}`
      }));
    }
  }, [location.search]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Sorry This Form Is Unavailable Now Please Contact Through the contact details");
    setFormData({ name: '', phone: '', email: '', subject: '', message: '' });
    const contactInfo = document.getElementById('contact-info-panel');
    if (contactInfo) {
      contactInfo.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="contact-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Get in touch with our fire safety experts and engineering team today.</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="section bg-light">
        <div className="container">
          <div className="contact-wrapper">

            {/* Contact Info & Map */}
            <div className="contact-info-panel" id="contact-info-panel">
              <h2>Get In Touch</h2>
              <p className="contact-intro">
                Whether you need a comprehensive fire safety audit, have questions about our equipment,
                or want to schedule a maintenance visit, we are here to help.
              </p>

              <div className="info-items">
                <div className="info-item">
                  <div className="info-icon">📍</div>
                  <div>
                    <h4>Head Office</h4>
                    <p>157 A 1/1 ,<br />Dharmapala Mawatha ,<br />Colombo 07 , 00700,<br />Sri Lanka</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">📞</div>
                  <div>
                    <h4>Phone</h4>
                    <p>+94 77 655 6000 (Hot Line)<br />+94 71 655 6000 (Whatsapp Only)<br />+94 113 495 900</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">✉️</div>
                  <div>
                    <h4>Email</h4>
                    <p>info@esseltech.lk</p>
                  </div>
                </div>
              </div>

              {/* Map Embedded */}
              <div className="map-container">
                <iframe
                  title="Esseltech Engineering Location"
                  src="https://maps.google.com/maps?q=6.9149423,79.8598682&t=&z=17&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="250"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade">
                </iframe>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-panel">
              <h2>Send a Message</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required placeholder="Kavinda Dilshan" />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required placeholder="service@gmail.com" />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} placeholder="+94 71 234 5678" />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} placeholder="How can we help?" />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea id="message" name="message" rows="5" value={formData.message} onChange={handleChange} required placeholder="Please describe your requirements..."></textarea>
                </div>

                <button type="submit" className="btn btn-primary submit-btn">Send Message</button>
              </form>
            </div>

          </div>
        </div >
      </section >
    </div >
  );
}

export default Contact;